import { AssetList } from '@goldcast/api/content';
import { getEnvConfig } from '@/constants';
import { Clip } from '@/domains/asset';

export function getClipThumbnailUrl(clip: Clip | AssetList): string {
  return `${getEnvConfig('CLOUDFRONT_STATIC_ASSET_URL')}${getEnvConfig('THUMBNAIL_ROOT_FOLDER')}${
    clip.content!.project.id
  }/${clip.content!.id}/thumbnails/${clip.asset_metadata.id}.png`;
}
